const SectionNavigation = ({ items }) => {
  const handleNavClick = (targetId) => {
    if (targetId.startsWith('#')) {
      const element = document.querySelector(targetId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  };

  return (
    <div className="-mx-[30px] px-[30px] flex gap-5 mb-5 py-2 border-b border-solid border-[#e4e4e4]" data-spm="dh">
      {items.map((item, index) => (
        <a
          key={index}
          data-spm={item.spm || index + 1}
          href={item.href || '#'}
          className="text-gray-600 hover:bg-gray-100 hover:text-blue-500 px-2 py-1 rounded cursor-pointer"
          onClick={(e) => {
            if (item.targetId) {
              e.preventDefault();
              handleNavClick(item.targetId);
            }
          }}
        >
          {item.label}
        </a>
      ))}
    </div>
  );
};

export default SectionNavigation;
